/*
 * File: 客户模块-客户系-一页纸列表
 */
<template>
    <el-dialog
        :visible="visible"
        title="客户一页纸列表"
        width="50vw"
        custom-class="one-paper-list-dialog"
        destroy-on-close
        append-to-body
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="handleClose"
    >
        <OnePaperList ref="onePaperListRef" :config="config.onePaper" :api="getCustomeOnePageList" :params="detailData" />
    </el-dialog>
</template>

<script>
import { ref, reactive } from '@vue/composition-api';
import OnePaperList from '@/modules/mdm/views/customerModules/customerManage/component/paperDialog/component/list.vue';
import { getCustomeOnePageList } from '@mdm/api/customer/customerManage.js';
import { config as configStatic } from '../config';

export default {
    components: { OnePaperList },
    props: {},
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const visible = ref(false);
        const config = reactive(configStatic);
        const detailData = ref({});

        const show = (val) => {
            visible.value = true;
            detailData.value = { pageStatus: '1', customerGroupCode: val.customerGroupCode, customerOwnerCode: val.customerManager, queryType: val.queryType };
            setupContext.root.$nextTick(() => {
                setupContext.refs.onePaperListRef.onePaperList.getList();
            });
        };
        const handleClose = () => {
            visible.value = false;
        };

        return {
            visible,
            config,
            detailData,
            show,
            handleClose,
            getCustomeOnePageList
        };
    }
};
</script>
